import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import TestWrapper from "../Inward/TestWrapper";
import Outward_logo from "../../../assets/assets/noun_outward.svg";
import CheckCircle from "../../../assets/assets/check-circle.svg";
import Button from "../../Button/Button";
import Spinner from "react-spinner-material";
import { tests } from "./tests";
import SuccessModal from "../Inward/SuccessModal";
import { useHistory } from "react-router-dom";
import {
  checkSuccess,
  checkSuccess2,
  checkSuccess3,
  checkSuccess4,
  reduxActions,
  reduxState,
} from "./OutwardTest/Functions";
import ShowXmlData from "./OutwardTest/ShowXmlData";
import ContinueSuccessModal from "../Inward/ContinueSuccessModal";

const OutwardTest = (props) => {
  const {
    initiateTest,
    isInitiatingTest,
    initiateSuccess,
    runEachTest,
    testItems,
    nameEnquiry,
    fundTransfer,
    statusQuery,
    isRunningNE,
    isRunningFT,
    isRunningSQ,
    runNESuccess,
    runFTSuccess,
    runSQSuccess,
    submitOutwardTest,
    submitTestSuccess,
    isSubmitting,
    error,
    clearNipTestState,
  } = props;

  const appId = props.location.state && props.location.state.appId;
  const type = props.location.state && props.location.state.type;

  const [state, setState] = useState({
    stepIndex: 1,
    showTests: true,
    showXml: false,
  });
  const testId = testItems && testItems.nipTestId;
  const payload = { nipTestId: testId };
  const history = useHistory();
  const [modal, setModal] = useState({
    visible: false,
    visible2: false,
  });

  useEffect(
    () => {
      clearNipTestState();
      const payload = {
        applicationId: appId,
      };
      const type = "outward";
      initiateTest(type, payload);
    },
    // eslint-disable-next-line
    [clearNipTestState, initiateTest]
  );

  const showSteps = (id) => {
    setState({
      ...state,
      showTests: true,
      stepIndex: id,
    });
  };

  const showAllLogs = (id, name) => {
    setState({
      stepIndex: id,
      showXml: true,
      showTests: true,
    });
    runEachTest(name, payload);
  };

  const closeBar = (id) => {
    setState({
      stepIndex: id + 1,
      showXml: false,
    });
  };

  const submitTest = () => {
    submitOutwardTest(payload);
  };

  useEffect(() => {
    if (submitTestSuccess && type !== "inward_outward_integration") {
      setModal({ ...modal, visible: true });
    }
    if (submitTestSuccess && type === "inward_outward_integration") {
      setModal({ ...modal, visible2: true });
    }
    // eslint-disable-next-line
  }, [submitTestSuccess, setModal]);

  const hide = () => {
    setModal({ ...modal, visible: false });
    history.push({
      pathname: `/nip/integration/${appId}`,
      state: {
        id: appId,
      },
    });
  };

  const hide2 = reRoute(setModal, modal, history, appId, type);

  return (
    <TestWrapper logo={Outward_logo} name={"Outward"}>
      {isInitiatingTest ? (
        <div className="center-spinner">
          <Spinner
            size={120}
            color={"#047558"}
            spinnerwidth={5}
            visible={true}
          />
        </div>
      ) : initiateSuccess ? (
        <div className="nip-outward">
          {tests &&
            tests.map((test) => (
              <div
                className={checkSuccess(
                  state,
                  test,
                  runNESuccess,
                  runFTSuccess,
                  runSQSuccess
                )}
                key={test.id}
              >
                <div
                  className={checkSuccess2(
                    test,
                    runNESuccess,
                    runFTSuccess,
                    runSQSuccess
                  )}
                >
                  <img src={CheckCircle} alt="checked" />
                </div>

                <div className="right">
                  <button
                    data-testid={`showSteps${test.id}`}
                    className="title"
                    disabled={state.stepIndex !== test.id}
                    onClick={() => showSteps(test.id)}
                  >
                    {test.title}
                    {checkSuccess3(
                      test,
                      runNESuccess,
                      runFTSuccess,
                      runSQSuccess
                    ) && <div className="title-passed">Passed</div>}
                    {checkSuccess4(
                      test,
                      runNESuccess,
                      runFTSuccess,
                      runSQSuccess,
                      error
                    ) && <div className="title-failed">Failed</div>}
                  </button>
                  <div className="subtitle">{test.subtitle}</div>

                  {state.showTests && state.stepIndex === test.id ? (
                    test.steps.map((step) => (
                      <div className="steps" key={step.id}>
                        <div className="subtitle2">{step.name}</div>

                        {!state.showXml && (
                          <div className="flex-button">
                            <Button
                              width="151px"
                              height="50px"
                              text="RUN TEST"
                              type="button"
                              testId="showLogs"
                              onClick={() => showAllLogs(test.id, test.type)}
                            />
                          </div>
                        )}
                        {state.showXml && (
                          <ShowXmlData
                            nameEnquiry={nameEnquiry}
                            fundTransfer={fundTransfer}
                            statusQuery={statusQuery}
                            isRunningNE={isRunningNE}
                            isRunningFT={isRunningFT}
                            isRunningSQ={isRunningSQ}
                            runNESuccess={runNESuccess}
                            runFTSuccess={runFTSuccess}
                            runSQSuccess={runSQSuccess}
                            error={error}
                            closeBar={closeBar}
                            state={state}
                            test={test}
                            showAllLogs={showAllLogs}
                          />
                        )}
                      </div>
                    ))
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div className="nip-error">Error Initiating Outward Test</div>
      )}

      <br />
      {runNESuccess && runFTSuccess && runSQSuccess && (
        <div className="flex-button">
          <Button
            testId="submitTest"
            onClick={() => submitTest()}
            disabled={isSubmitting}
            width="151px"
            height="50px"
            text={isSubmitting ? "SUBMITTING.." : "SUBMIT"}
            type="submit"
          />
        </div>
      )}

      {submitTestSuccess && type !== "inward_outward_integration" ? (
        <SuccessModal hide={hide} visible={modal.visible} />
      ) : (
        <ContinueSuccessModal hide={hide2} visible={modal.visible2} />
      )}
    </TestWrapper>
  );
};

propsValidate();
const mapStateToProps = reduxState();
const mapDispatchToProps = reduxActions();

export default connect(mapStateToProps, mapDispatchToProps)(OutwardTest);

function reRoute(setModal, modal, history, appId, type) {
  return () => {
    setModal({ ...modal, visible2: false });
    history.push({
      pathname: "/nip/integration/test/inward",
      state: { appId: appId, type: type },
    });
  };
}

export function propsValidate() {
  OutwardTest.propTypes = {
    clearNipTestState: PropTypes.func,
    error: PropTypes.any,
    fundTransfer: PropTypes.any,
    initiateSuccess: PropTypes.any,
    initiateTest: PropTypes.func,
    isInitiatingTest: PropTypes.any,
    isRunningFT: PropTypes.any,
    isRunningNE: PropTypes.any,
    isRunningSQ: PropTypes.any,
    isSubmitting: PropTypes.any,
    location: PropTypes.shape({
      state: PropTypes.any,
    }),
    nameEnquiry: PropTypes.any,
    runEachTest: PropTypes.func,
    runFTSuccess: PropTypes.any,
    runNESuccess: PropTypes.any,
    runSQSuccess: PropTypes.any,
    statusQuery: PropTypes.any,
    submitOutwardTest: PropTypes.func,
    submitTestSuccess: PropTypes.any,
    testItems: PropTypes.shape({
      nipTestId: PropTypes.any,
    }),
  };
}
